import axios from "axios";

const headers = { "Content-Type": "application/json" };
if (localStorage.getItem('super_admin_token')) {
  headers.Authorization = localStorage.getItem('super_admin_token');
}
export default axios.create({
  baseURL: process.env.VUE_APP_SUPER_ADMIN_API_URL,
  headers: headers
});